module.exports = __webpack_public_path__ + "static/img/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-4.9c45791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promo/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-4.png
// module id = TOHJ
// module chunks = 0